var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DriveActionsOverTime from '@web/components/Apps/Drive/DriveActionsOverTime';
import DriveDocumentsActivity from '@web/components/Apps/Drive/DriveDocumentsActivity';
import DriveSummary from '@web/components/Apps/Drive/DriveSummary';
import InsightsTable from '@web/components/Apps/Drive/InsightsTable';
import { ActivityLabelFilterSelect } from '@web/components/Filters/Elements/ActivityLabel';
import StickyFilters from '@web/components/Filters/StickyFilters';
import { trpc } from '@web/lib/trpc';
import { useFilters } from '@web/utility/hooks/useFilters';
import { ActivityLabelTargetEnum } from '@workalizer/shared/enums';
export function DriveTab() {
    var _a = useFilters(), userId = _a.user, dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnitId = _a.orgUnit, activityLabelId = _a.activityLabel;
    var documentActivityData = trpc.documentActivity.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        activityLabelId: activityLabelId
    });
    var documentActivity = (documentActivityData === null || documentActivityData === void 0 ? void 0 : documentActivityData.data) ? documentActivityData === null || documentActivityData === void 0 ? void 0 : documentActivityData.data : null;
    if (!documentActivity) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, { additionalFilters: _jsx(ActivityLabelFilterSelect, { labelTargets: [
                        ActivityLabelTargetEnum.DOCUMENT_TITLES,
                        ActivityLabelTargetEnum.ALL
                    ] }) }), _jsxs("div", __assign({ className: "flex flex-col mx-1 gap-20 mt-5" }, { children: [_jsx(DriveSummary, {}), _jsx(DriveActionsOverTime, {}), _jsx(DriveDocumentsActivity, {}), _jsx(InsightsTable, {})] }))] }));
}
